import React,{useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import Form from 'olive-react-myoneui/lib/Form';
import FloatingLabel from 'olive-react-myoneui/lib/FloatingLabel';
import DropdownEnquiry from './student-dashboard/DropdownCommon';
import { Button } from 'olive-react-myoneui';
import serialize from 'form-serialize';
import axios from 'axios';
import { API_URL } from '../constants/config';
import { checkCircleIcon, exclamationIcon } from '../constants/icons';
import { getAllEnquiryFields } from '../../src/api/initialApis';
import { getCache } from "./Page/utils/cacheManager";

const EnquiryForm = ({setModalThankYouShow, fromEnquiryPage, setEnquirySubmitted, setShowSuccessSnack, setEnquirySuccessTitle, setEnquirySuccessMessage}) => {
    // const fields = useSelector((state) => state.user.fields);
    const [fields, setFields]                   = useState({});
    const miscellaneous = useSelector((state) => state.user.miscellaneous);
    const token         = fields?.token;
    const [validated, setValidated] = useState(false);
    const [showResults, setShowResults] = React.useState(false);
    const [mandatoryFirst, setMandatoryFirst] = useState(false);
    const [productType, setProductType]         = useState('4');
    const [productName, setProductName]         = useState('');
    const [showEnquiryForm, setShowEnquiryForm] = useState(true);
    const [items, setItems]                     = useState({});
    const [inProgress, setInProgress]           = useState(false);
    const fieldNames = {};

    useEffect(() => {
        const init = async () => {
          const content = await getCache("all_enquiry_fields", getAllEnquiryFields, {}, 2592000);
          setFields(content.fields);
          setEnquirySuccessTitle(content.fields.success_title);
          setEnquirySuccessMessage(content.fields.success_msg);
        }
        init();
        let query = Object.fromEntries(new URLSearchParams(window.location.search))
        if (query.name) {
            setProductName(query.name);
        }
      }, []);

    function isPhoneNumber(number) {
        var phoneno = /^[+]{0,1}[0-9]{7,16}$/;
  
        if (number.match(phoneno)) {
        //    console.log("1");
           return true;
        }
        return false;
    }

    function isNumber(number){
        let regex = /^[+]{0,1}[0-9]{0,16}$/;
        if(number.match(regex)){
            return true;
        }
        return false;
    }


    function validateEmail(email) {
        var filter = /\S+@\S+\.\S+/;
        return filter.test(email);
    }

    function isValidEmailOnChange(email){
        const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
        return emailRegex.test(email);
    }
  
    const handleSubmit = (event) => {
        let errorCount    = 0;
        let emailFill     = '';
        // console.log(event.target.elements.new_number.value);
        const form = event.currentTarget;
        const body = serialize(form, {hash: true, empty: true});
        event.preventDefault();
        event.stopPropagation();
    //   if (form.checkValidity() === false) {
    //     event.preventDefault();
    //     event.stopPropagation();
    //   }

      fields.fields.map((item) => {
        if(item.delete === '0'){
            fieldNames[item.id] = item.label;
            if(item.mandatory === '1' && body[item.id] == ''){
                console.log('erro', body[item.id]);
            }
            switch(item.type){
                case '3':
                    //email
                    if(body[item.id] != ''){
                        if(!validateEmail(body[item.id])){
                            //error
                            console.log('email error');
                            setItems((prevObject) => {
                                return { ...prevObject, [item.id] : {'className' : 'is-server-invalid', 'value' :body[item.id], errorMsg : 'Please enter a valid email', type : item.type} }
                            });
                            errorCount++;
                        }
                        emailFill = body[item.id];
                    }

                    break;
                case '4':
                    if(body[item.id] != ''){
                        if(!isPhoneNumber(body[item.id])){
                            //error  
                            setItems((prevObject) => {
                                return { ...prevObject, [item.id] : {'className' : 'is-server-invalid', 'value' :body[item.id], errorMsg : 'Please enter a valid phone number', type : item.type} }
                            });
                            errorCount++;
                        }
                    }

                    break;
                    return;
                break;
                default :
                    return;
            };
        }
      })
  
      setValidated(true);
    //   console.log(form.checkValidity());
      if (form.checkValidity() === true && errorCount == 0) {
        setInProgress(true);
        const headers = {
            // 'Content-Type': 'application/json',
            // 'Authorization': `Bearer ${secret}`
            // 'Authorization': `Bearer bb289a32abaac489fc6209044659e5c29093bg33`
        }
        var data = {
            "is_ajax": true,
            "form_data": body,
            "form_labels": fieldNames,
            "email_fill": emailFill,
            "token":token
        }
        axios.post(`${API_URL}api/homepage/save_enquiry_new`,data, {
            headers
        })
        .then((response) => {
            // console.log(response);
            document.getElementById("enquiry-form").reset();
            initItems();
            setValidated(false);
            setShowSuccessSnack(true);
            setShowEnquiryForm(false);
            
            if(fromEnquiryPage === true){
                setModalThankYouShow(true);
            } else {
                setEnquirySubmitted(true);
            }
            setInProgress(false);
        })
        .catch((error) => {
            setInProgress(false);
            console.log('auth', error);
            
            // Error
            if (error.response) {
            console.log('err1', error.response);
            } else if (error.request) {
                console.log('err2',error.request);
            } else {
                console.log('Error', error.message);
            }
            console.log(error.config);
        });
        }
    };

    const onInputChange = (e, itemType='', itemId='') => {
        // console.log('itemtype', itemType, itemId);
        if(itemType == '2' && itemId != ''){
            const val = e.name;
            setItems((prevObject) => {
                return { ...prevObject, [itemId] : val }
            })
        } else {
            const type  = e.target.type? e.target.type : '';
            const val   = e.target.value ? e.target.value : '';
            const id    = e.target.id ? e.target.id : '';
            // console.log('val' ,val, type, id);
    
            switch(itemType){
                case '4' :
                    //phone
                    if(isNumber(val)){
                        setItems((prevObject) => {
                            return { ...prevObject, [id] : {'className' : '', 'value' :val, errorMsg : 'This field is required', type : itemType} }
                        });
                    } 
                    // else {
                    //     setItems((prevObject) => {
                    //         return { ...prevObject, [id] : {'className' : 'is-server-invalid', 'value' :val, errorMsg : 'Please enter a valid phone number', type : itemType} }
                    //     });
                    // }
                    break;
                case '3' :
                    //email
                    // if(isValidEmailOnChange(val)){
                        setItems((prevObject) => {
                            return { ...prevObject, [id] : {'className' : '', 'value' :val, errorMsg : 'This field is required', type : itemType} }
                        });
                    // }
                    break;
                case '5':
                    //textarea
                    setItems((prevObject) => {
                        return { ...prevObject, [id] : {'className' : '', 'value' :val, errorMsg : 'This field is required', type : itemType} }
                    });
                    break;
                case '1':
                    //text
                    setItems((prevObject) => {
                        return { ...prevObject, [id] : val }
                    });
                    break;
                case '2':
                    //dropdown
                    setItems((prevObject) => {
                        return { ...prevObject, [id] : val }
                    });
                    break;
                
                
            }
        }

        // setValue(val);
        // setMenuValue(val);
        // setShow(true);
    };

    const initItems = () => {
        if(fields && fields.fields){
            let mandatoryCount = 0;
            fields?.fields?.map((item) => {
                if(item.delete === '0'){
                    setItems((prevObject) => {
                        return { ...prevObject, [item.id] : {'value' : '', 'className' : '', 'type' :item.type, 'errorMsg' : 'This field is required.', mandatory: item.mandatory} }
                    });
                    // console.log('items id', item.id);
                    if(item.mandatory === '1'){
                        mandatoryCount++;
                    }
                }
            });
    
            if(mandatoryCount === 0){
                setMandatoryFirst(true);
            }
        }
    }

    useEffect(() => {
        initItems();
        // console.log('itemnew', items);
    },[fields]);

    let mandatoryItemId = 0;
    let counter = 0;
    
    return(
        <Form noValidate validated={validated} className="server-validated" id='enquiry-form' onSubmit={handleSubmit}>
            {fields?.enquiry_form_title && (
                <h3>{fields.enquiry_form_title}</h3>
            )}
            {fields?.enquiry_form_tag && (
                <p>{fields.enquiry_form_tag}</p>
            )}
            <input type="hidden" value="" name="product_id"/>
            <input type="hidden" value={productType} name="product_type"/>
            <input type="hidden" value={productName} name="product_name"/>
            <input type="hidden" value="" name="user_id"/>
            <input type="hidden" value={miscellaneous?.account_id} name="account_id"/>
        { 
            fields?.fields?.map((item) => {
                if(item.delete === '0'){
                    fieldNames[item.id] = item.label;
                    if(mandatoryFirst === true && counter == 0){
                        mandatoryItemId = item.id;
                        counter++;
                    }
                    switch(item.type){
                        case '1' : 
                            return(
                                <FloatingLabel
                                controlId={item.id}
                                label={item.label}
                                className="mb-3"
                                >
                                <Form.Control type="text" className={items[item.id]?.className} value={items[item.id]?.value} name={item.id} placeholder={item.label} required={item.mandatory === '1' || mandatoryItemId == item.id} defaultValue={items[item.id]} onChange={(obj) => onInputChange(obj, item.type, item.id)}/>
                                <Form.Control.Feedback type="invalid">
                                   {exclamationIcon} <span className="message-warning">{items[item.id]?.errorMsg}</span>
                                </Form.Control.Feedback>
                                {/* <div class="invalid-feedback">
                                  Duis aute irure dolor in reprehenderit in volupta.
                                </div> */}
                                </FloatingLabel>
                            );
                        break;
                        case '2' :
                            //option
                            let options = item.option.split(',');
                            let enquiryDropItems = [];
                            let optionsHtml = options.map((option) => {
                                return <option value={option}>{option}</option>
                            })
                            options.map((option) => {
                                enquiryDropItems.push({'name' : option});
                            });
                            return(
                                // <FloatingLabel
                                // controlId="floatingInputName"
                                // label={item.id}
                                // className="mb-3"
                                // >
                                //     <Form.Select aria-label="" name={item.id} required={item.mandatory === '1'}>
                                //         <option value="">Choose from option</option>
                                //         {optionsHtml}
                                //     </Form.Select>
                                //     <Form.Control.Feedback type="invalid">
                                //     Please fill the field.
                                //     </Form.Control.Feedback>
                                // </FloatingLabel>
                                <DropdownEnquiry defaultValue={items[item.id]?.value} itemName={item.id} items={enquiryDropItems} label={item.label} onChange={(obj) => onInputChange(obj, item.type, item.id)} required={item.mandatory === '1' || mandatoryItemId == item.id} className="mb-3" />
                            );
                        break;
                        case '3' :
                            //email
                            return(
                                <FloatingLabel
                                    controlId={item.id}
                                    label={item.label}
                                    className="mb-3"
                                    >
                                    <Form.Control className={items[item.id]?.className} type="text" value={items[item.id]?.value} placeholder={item.label} name={item.id} required={item.mandatory === '1' || mandatoryItemId == item.id} onChange={(obj) => onInputChange(obj, item.type, item.id)}/>
                                    <Form.Control.Feedback type="invalid">
                                        {exclamationIcon} <span className="message-warning">{items[item.id]?.errorMsg}</span>
                                    </Form.Control.Feedback>
                                </FloatingLabel>
                            )
                        break;
                        case '4' :
                            //phone
                            return(
                                <FloatingLabel
                                    controlId={item.id}
                                    label={item.label}
                                    className="mb-3"
                                    >
                                    <Form.Control className={items[item.id]?.className} type="tel" value={items[item.id]?.value} placeholder={item.label} name={item.id} required={item.mandatory === '1' || mandatoryItemId == item.id} onChange={(obj) => onInputChange(obj, item.type, item.id)}/>
                                    <Form.Control.Feedback type="invalid">
                                        {exclamationIcon} <span className="message-warning">{items[item.id]?.errorMsg}</span>
                                    </Form.Control.Feedback>
                                </FloatingLabel>
                            )
                        break;
                        case '5' :
                            //textarea
                            return(
                                <FloatingLabel controlId={item.id} label={item.label} className="mb-3">
                                    <Form.Control
                                        as="textarea"
                                        placeholder={item.label}
                                        required={item.mandatory === '1' || mandatoryItemId == item.id}
                                        onChange={(obj) => onInputChange(obj, item.type, item.id)} 
                                        name={item.id}
                                        className={items[item.id]?.className}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {exclamationIcon} <span className="message-warning">This field is required.</span>
                                    </Form.Control.Feedback>
                                </FloatingLabel>
                            )
                        break;
                        default : 
                                return;
                    }
                }
            }) 
        }  
        <Button variant="secondary" type="submit" className="mt-3" disabled={inProgress}>Submit</Button>
    </Form>
    )
}

export default EnquiryForm;